
<div class="listing-grid" *ngIf="key?.forceChange">
   <img *ngIf="key?.forceChange" src="assets/img/logo.png" class="img-fluid">
   <div class="detail-row">
      <h2>Change Password</h2>
      <div class="m-t-20">
         <div class="col-md-12">
            <form  class="mx-1" [formGroup]="formData" (ngSubmit)="onSubmit()">
               <div class="row">
                  <div class="col-md-4">
                     <div class="form-group">
                        <label for="password">Old Password</label>
                        <input type="password" name="password" formControlName="old_password" [ngClass]="{ 'is-invalid': f.old_password.touched && f.old_password.errors }" class="form-control" required="true">
                        <small class="error" *ngIf="f?.old_password?.touched && f?.old_password?.errors?.required"> The OldPassword field is required </small>
                        <!-- <span class="error"></span> -->
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-4">
                     <div class="form-group">
                        <label for="password">New Password</label>
                        <input type="password" name="password1" formControlName="new_password" [ngClass]="{ 'is-invalid': f.new_password.touched && f.new_password.errors }" class="form-control" required="true">
                        <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.required"> The Password field is required </small>
                        <!-- <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.minlength"> The Password field must be at least 8 characters </small> -->
                        <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.pattern"> The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number </small>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-4">
                     <div class="form-group">
                        <label for="confirm_password" >Confirm Password</label>
                        <input type="password" name="password_confirmation" formControlName="new_password_re" [ngClass]="{ 'is-invalid': f.new_password_re.touched && f.new_password_re.errors }" class="form-control" required="true">
                        <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.required"> The Confirm Password field is required </small>
            <!-- <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.minlength"> The Confirm Password field must be at least 8 characters </small> -->
            <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.mustMatch"> The NewPassword confirmation does not match </small>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-4">
                     <!-- <label>&nbsp;</label><br> -->
                     <!-- <input type="hidden" name="_token"> -->
                     <button type="submit" class="btn btn-primary">Change Password</button>
                  </div>
               </div>
            </form>
         </div>
      </div>
   </div>
   <h6 style=" text-align: center; color: #fff !important; ">info@diamondsite.com</h6>
   <div class="table-responsive data-table"></div>
</div>


<form method="post" *ngIf="resetPwd" [formGroup]="formData" (ngSubmit)="onSubmit()">
      <div class="form-group row">
         <label class="col-form-label col-4">Password</label>
         <div class="col-8 form-group-feedback form-group-feedback-right">
            <input placeholder="Password" type="password" name="userchangepasswordpassword" formControlName="new_password" [ngClass]="{ 'is-invalid': f.new_password.touched && f.new_password.errors }"
                  data-vv-as="Password" class="form-control" aria-required="true" aria-invalid="false" />
                  <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.required"> The Password field is required </small>
                  <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.minlength"> The Password field must be at least 8 characters </small>
                  <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.pattern"> The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number </small>
         </div>
      </div>
      <div class="form-group row">
         <label class="col-form-label col-4">Confirm Password</label>
         <div class="col-8 form-group-feedback form-group-feedback-right">
            <input placeholder="Confirm Password" type="password" name="userchangepasswordcpassword" formControlName="new_password_re" [ngClass]="{ 'is-invalid': f.new_password_re.touched && f.new_password_re.errors }"
                  data-vv-as="Confirm Password" class="form-control" aria-required="true"
                  aria-invalid="false" />
            <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.required"> The Confirm Password field is required </small>
            <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.minlength"> The Confirm Password field must be at least 8 characters </small>
            <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.mustMatch"> The Confirm Password confirmation does not match </small>
         </div>
      </div>
      <div class="form-group row">
         <label class="col-form-label col-4">Transaction Code</label>
         <div class="col-8 form-group-feedback form-group-feedback-right">
            <input placeholder="Transaction Code" type="password" name="userchangepasswordmpassword" formControlName="trans_pwd" [ngClass]="{ 'is-invalid': f.trans_pwd.touched && f.trans_pwd.errors }"
                  data-vv-as="Transaction Code" class="form-control" aria-required="true"
                  aria-invalid="false" />
            <small class="error" *ngIf="f?.trans_pwd?.touched && f?.trans_pwd?.errors?.required"> The Transaction Code field is required </small>
         </div>
      </div>
      <div class="form-group row">
         <div class="col-12 text-right">
            <button type="submit" class="btn btn-dark">
                  submit
                  <i class="fas fa-sign-in-alt ml-1"></i>
            </button>
         </div>
      </div>
</form>

<div class="listing-grid" *ngIf="key?.changePwd">
   <div class="detail-row">
      <h5>
         Change Password
         <button type="button" data-dismiss="modal" class="close">×</button>
      </h5>
      <div class="m-t-20">
         <div class="col-md-12">
            <form  class="mx-1" [formGroup]="formData" (ngSubmit)="onSubmit()">
               <div class="row">
                  <div class="col-md-12">
                     <div class="form-group">
                        <input type="password" placeholder="Transaction Password" formControlName="trans_pwd" [ngClass]="{ 'is-invalid': f.trans_pwd.touched && f.trans_pwd.errors }" name="master_password" class="form-control" required="true">
                        <small class="error" *ngIf="f?.trans_pwd?.touched && f?.trans_pwd?.errors?.required"> The Transaction Code field is required </small>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-12">
                     <div class="form-group">
                        <input type="password" name="password" placeholder="New Password" formControlName="new_password" [ngClass]="{ 'is-invalid': f.new_password.touched && f.new_password.errors }" class="form-control" required="true">
                        <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.required"> The Password field is required </small>
                        <small class="error" *ngIf="f?.new_password?.touched && f?.new_password?.errors?.minlength"> The Password field must be at least 8 characters </small>
                        <small class="error" *ngIf="f?.new_password?.touched && !f?.new_password?.errors?.minlength && f?.new_password?.errors?.pattern"> The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number </small>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-12">
                     <div class="form-group">
                        <input type="password" name="password_confirmation" placeholder="Confirm Password" formControlName="new_password_re" [ngClass]="{ 'is-invalid': f.new_password_re.touched && f.new_password_re.errors }" class="form-control" required="true">
                        <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.required"> The Confirm Password field is required </small>
                        <small class="error" *ngIf="f?.new_password_re?.touched && f?.new_password_re?.errors?.minlength"> The Confirm Password field must be at least 8 characters </small>
                        <small class="error" *ngIf="f?.new_password_re?.touched && !f?.new_password_re?.errors?.minlength && f?.new_password_re?.errors?.mustMatch"> The Confirm Password confirmation does not match </small>
                     </div>
                  </div>
               </div>
               
               <div class="row">
                  <div class="col-md-12">
                     <input type="hidden" name="_token" value="jkhVcq4GIDIzZ0tsDjpH9jGdu4fknzB5j6k6jiyA">
                     <button type="submit" class="btn btn-dark w-100">change password <i class="mdi mdi-chevron-right-circle"></i></button>
                  </div>
               </div>
            </form>
         </div>
      </div>
   </div>
   <div class="table-responsive data-table"></div>
</div>